<app-header></app-header>

<app-popup *ngIf="show" (event)="show = $event"></app-popup>

<section class="hero" id="hero" [ngClass]="{ 'is-active': isActive }">
  <div class="container">
    <article>
      <h1>ZOOMYBOX ... the inspired path to math success</h1>
      <p>Creative Math projects delivered twice a month!</p>

      <span class="btn-wrap btn-wrap1">
        <a class="btn btn--white" routerLink="/pages/public/contacts"
          ><span class="btn-text">Join NOW</span
          ><span class="btn-arrow fa fa-long-arrow-right"></span
        ></a>
      </span>
      <span class="btn-wrap btn-wrap2">
        <a class="btn btn--transparent" routerLink="/pages/public/contacts"
          ><span class="btn-text">Give a GIFT</span
          ><span class="btn-arrow fa fa-long-arrow-right"></span
        ></a>
      </span>
    </article>

    <article>
      <div class="img-wrapper">
        <img
          src="/assets/images/pages/main/hero.jpg"
          alt="Mathematics Learning Programs"
        />
      </div>
    </article>
  </div>

  <div class="hero__small-box">
    <svg
      data-name="Layer 1"
      width="260"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 285 170.01"
    >
      <path
        fill="#fff"
        d="M233.39 57.06c0 20.88-.15 40 .06 59 .1 9.34 1 18.68 1.23 28a5.86 5.86 0 0 1-2 4.36c-11.89 8-23.9 15.74-35.9 23.54-3.14 2-6.14 1.32-9.8.67a154.55 154.55 0 0 0-25.55-1.87c-13.72-.14-27.45.26-41.17.5-13.42.22-26.84.27-40.24.87-10.06.45-20.08 1.74-30.14 2.44-3.76.26-6-.45-5.79-5.74 1.1-25.3 1.54-50.63 2.2-75.95.07-2.74 0-5.49 0-9.54-4.84.29-9.42.76-14 .76-2.21 0-4.42-.9-6.62-1.39.58-2 .83-4.16 1.79-6 7-13.29 14.22-26.5 21.72-40.43a38.47 38.47 0 0 0-3.66 1.28C33.65 43.48 21.85 49.36 10 55.09c-.92.44-2.3-.09-3.47-.18.31-1.12.25-2.73 1-3.27a53.27 53.27 0 0 1 8.82-5.54c11-5.11 22.25-9.6 33-15.11 6.47-3.32 12.33-7.92 18.23-12.26a54.89 54.89 0 0 1 34.19-11.27c21.63.12 43.27-1.72 64.91-2 18.37-.22 36.74.66 55.11 1 1.83 0 4 .39 5.44-.38 6.65-3.48 11.67-.21 16.47 3.65 10.36 8.35 21.41 15.33 34 20 4.3 1.6 7.95 5.16 11.6 8.18 3.07 2.55 2.75 5.53.32 8.7-8 10.43-18.77 17.47-29.52 24.51-1.2.79-4.13-.14-5.77-1.1-6.62-3.77-13.02-7.97-20.94-12.96zm-46 108.52c-.25-5.4-.82-11.24-.74-17.08.3-22 .85-44.09 1.18-66.14 0-1.53-.95-3.07-1.46-4.61l-1.43.61 2.14 4.64-5.38 6.58c-1.57-1.42-2.74-2.55-4-3.59-.93-.79-2-1.48-2.95-2.21l-.43.77 3 4.8-1.32 1.12-7.5-6.47-.7.78 4.58 5.84-1 1.21-5.72-3.86-1.44 2.48c-4.45-.79-4.61-8.6-10.58-5.61.46 1.48.89 2.89 1.8 5.82l-10.69-7.85 1.51 7.58-9.58-7.78c.36 3.25.49 4.49.67 6.13-7.89-4.61-7.89-4.61-8.65-.33l-10.39-4.62 2.43 6-.9.84-7.6-6-.87 1.17 1.76 4-2.06 1.79-4-7.31-1.27 1.31c.66 1.65 1.31 3.3 2.34 5.9l-13.57-6.26-1.14 3.31L87 84.11c.24 2.7.38 4.25.52 5.8-2.08-.7-2.9-2-4-3a32.81 32.81 0 0 0-4.4-2.73l2.31 6.24-1.36.81-6.16-7.08-.81.63 1.23 4.73-1.2.8-5.81-7.14.94 5.46-1.26.57c-.9-1.32-1.57-2.93-2.77-3.89s-2.89-1.22-4.94-2l2.91 7.33-1.4.79-7.1-8-1.22 1.13 2.31 5.85h-4.38c-.84 26.56-1.67 52.91-2.52 80.11 46.7-6.6 92.75-1.27 139.46-4.94zM30.8 79.42c4.25-.29 7.54-.82 10.8-.7 13 .49 26 1.66 39 1.69 29.43.08 58.85-.35 88.28-.61 1.83 0 3.82.08 5.44-.59s3.52-2 3.85-3.38c3.12-13.17 5.94-26.42 8.69-39-42.71-3.56-86 3.21-129.25 0a5 5 0 0 0-4 1.93C46 52.08 38.58 65.52 30.8 79.42zM192 170.63c12.94-8.77 24.62-16.63 36.19-24.67a5.39 5.39 0 0 0 1.91-3.94c-.09-7-.54-13.93-.78-20.89-.34-10.08-.78-20.17-.85-30.26 0-7.14.92-14.3.56-21.41-.22-4.34-2.09-8.59-3.21-12.83l-1.85 2.57c-4.61-7.89-7.72-9-12-3.75-.87-4.21-1.62-7.87-2.37-11.53l-1 .19c-.17 1.6-.34 3.21-.5 4.81l-1.68.24c-.69-3.06-1.39-6.13-2.23-9.79-.52 2.31-.87 3.88-1.23 5.45l-1.18-.1c-.64-1.45-1.28-2.91-1.87-4.23-.35 1.23-.74 2.59-1.49 5.16l-2.65-6C191.86 83 190 125.72 192 170.63zM288.44 43c-3.61-2.9-5.41-4.86-7.62-6-6.14-3.23-12.72-5.7-18.65-9.27-8.47-5.09-16.59-10.77-24.69-16.45-2.77-1.94-5-2.4-7.87-.35q-10.94 7.82-22.12 15.3c-3.11 2.08-6.51 3.71-9.09 5.15l60.29 35.57c4.59-3.27 9.85-6.66 14.7-10.55S283 47.84 288.44 43zM112.61 14.44l1.92-1.44c1.8 2.16 4.2 4 5.3 6.52 5 11.24 13.89 14 25.14 12.4a55.06 55.06 0 0 1 7.71-.05h19.95l-10.74-18.18 2-1.2c1 1.37 2.11 2.68 3 4.11 2.49 3.87 4.57 8 7.46 11.56a10 10 0 0 0 6.55 3.41c11.11.27 19.22-6.68 28.14-11.84L204.57 13l1.32-1 6.52 5.92 7.82-6.42h-25.07l10.77 9.88c-9.83-.07-11.58-12.14-21-10.66l11.42 14-1.15 1.24a22.13 22.13 0 0 1-3.81-2.74c-2.82-3.14-5.91-6.19-8-9.8-1.61-2.76-3.43-3.18-6.11-3-14.27.75-28.54 1.6-42.82 2.08-9.45.31-18.93.06-29.36.06l13.69 19.06h6zM88.34 33.51v-20.1L87.21 13c-4.16 6.58-8.33 13.16-13 20.53zm27-1.44L101.5 12.18l-5.5.25 12.53 19.64zm-10.47-.34L91.76 11.41v22l4.64-.83-4.48-7.86c6.77-.59 5.26 10.52 12.97 7.01zM81 16.92l-.56-.78c-2.63 1.55-6.21 2.5-7.65 4.8-2.14 3.39-2.75 7.73-4.12 12l2.54.34z"
        transform="translate(-6.5 -4.66)"
      />
      <path
        fill="#fff"
        d="M65.48 49.75l-2-.89q-4.09 8.93-8.21 17.84l2 .89c3.36-5.66 7.16-11.13 8.21-17.84zM59 48.55l-2.36-1.48-8 14.63L51 63zm109.71 1.3l-1.53-.59c-4.35 4.08-7.39 11.93-5.28 15.9zM151.36 11.91l-2 1.95 14.23 15.07 2-1.87zm32.14 17.58l2.29-1.67-11.64-16-2.21 1.61zm-50 .06l1.36-1.44c-5.08-9.83-9.5-14.22-12.84-12.52zm10.6-14.87l-2 1.81c4.19 4.36 5.67 11.18 11.87 13.72l1.18-1zM136 14l-1.64 1.26c3.14 8.29 7.44 13.91 11.71 14.26z"
        transform="translate(-6.5 -4.66)"
      />
      <path
        fill="#fff"
        d="M54.36 148.18v11.16l8 .44v1.55c-3.51 1.26-7.28 3-10.7 0-2.05-1.71-.02-11.56 2.7-13.15zM179.09 108.18V134h-1.39v-25.83zM65.48 49.75c-1 6.71-4.85 12.18-8.24 17.84l-2-.89 8.21-17.84zM59 48.55L51 63l-2.38-1.3 8-14.63zM168.73 49.85l-6.81 15.31c-2.11-4 .93-11.82 5.28-15.9zM226.7 124.52c.39 5.35.79 10.69 1.16 16a1.28 1.28 0 0 1-.38 1c-4.54 2.93-9.12 5.82-13.68 8.73l-1.25-1.95c3.92-3 9.38-5.21 11.32-9.17s.43-9.71.43-14.67zM233 42.76V26.87c3.57 2.02 3.83 9.86 0 15.89zM151.36 11.91l14.16 15.15-2 1.87-14.19-15.07zM183.5 29.49l-11.56-16.1 2.21-1.61 11.64 16zM133.46 29.55L122 15.59c3.34-1.7 7.76 2.69 12.84 12.52zM144.1 14.68l11.09 14.53-1.18 1c-6.2-2.54-7.68-9.36-11.87-13.72zM136 14l10.07 15.52c-4.27-.35-8.57-6-11.71-14.26z"
        transform="translate(-6.5 -4.66)"
      />
    </svg>
    <!-- <img src="/assets/images/pages/main/small-box.png"  alt="small-box"> -->
  </div>
  <!-- <div class="hero__mobile">
    <img src="/assets/images/pages/main/mobile1.png" alt="ZoomyBox">
  </div> -->
</section>

<section class="sub-hero" [ngClass]="block2Animate ? 'active' : ''">
  <div class="container">
    <article class="sub-hero-item sub-hero-item1">
      <div class="sub-hero-content">
        <div class="icon-wrapper">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="44"
            viewBox="0 0 40 44"
          >
            <path
              fill="#3fd76a"
              d="M29 25H15a3 3 0 0 0-3 3v2a1 1 0 0 0 1 1v5a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-5a1 1 0 0 0 1-1v-2a3 3 0 0 0-3-3zm0 11a1 1 0 0 1-1 1H16a1 1 0 0 1-1-1v-5h14zm1-7H14v-1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1z"
              transform="translate(-2)"
            />
            <path
              fill="#3fd76a"
              d="M39 21h-2V10a3 3 0 0 0-1.19-2.39A3.07 3.07 0 0 0 34 7h-5V3a3 3 0 0 0-3-3h-8a3 3 0 0 0-3 3v4h-5a3.07 3.07 0 0 0-1.79.59A3 3 0 0 0 7 10v11H5a3 3 0 0 0-3 3v10a5 5 0 0 0 5 5v2a3 3 0 0 0 3 3h24a3 3 0 0 0 3-3v-2a5 5 0 0 0 5-5V24a3 3 0 0 0-3-3zM7 37a3 3 0 0 1-3-3v-7h3zm0-12H4v-1a1 1 0 0 1 1-1h2zM18 2h8a1 1 0 0 1 1 1H17a1 1 0 0 1 1-1zm-1 3h10v2H17zm17 4l-2 6a3 3 0 0 1-2.88 2H25v-1a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1h-4.12A3 3 0 0 1 12 14.94L10.05 9zm-11 8v2h-2v-2zm12-4.84V41a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1V12.16l1.14 3.41A5 5 0 0 0 14.88 19H19v1a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1h4.12a5 5 0 0 0 4.74-3.42L35 12.16zM40 34a3 3 0 0 1-3 3V27h3zm0-9h-3v-2h2a1 1 0 0 1 1 1z"
              transform="translate(-2)"
            />
          </svg>
        </div>

        <h3>Traditional methods</h3>
        <p>
          Time-tested traditional methods: colorful workbooks, flashcards, and
          learning tools are designed for lasting success in Math
        </p>
      </div>
    </article>
    <article class="sub-hero-item sub-hero-item2">
      <div class="sub-hero-content">
        <div class="icon-wrapper">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="44"
            height="42"
            viewBox="0 0 44 42"
          >
            <path
              fill="#00c0ff"
              d="M22.2 18.8A5.2 5.2 0 0 0 17 24a1 1 0 0 0 2 0 3.21 3.21 0 0 1 3.2-3.2 1 1 0 0 0 0-2z"
              transform="translate(0 -1)"
            />
            <path
              fill="#00c0ff"
              d="M44 16a9 9 0 0 0-6.53-8.66A9.49 9.49 0 0 0 26 3.68 8 8 0 0 0 20 1a7.88 7.88 0 0 0-6.37 3.17A8.13 8.13 0 0 0 12 4a8 8 0 0 0-7.73 5.92 8 8 0 0 0-3.4 10.71A7.37 7.37 0 0 0 .1 23.9c0 4.8 4.69 8.7 10.45 8.7a12.13 12.13 0 0 0 3.45-.49 9.36 9.36 0 0 0 8.91 1.3 6 6 0 0 0 3.2 1.51 42.7 42.7 0 0 0 2 6.93C28.79 43 29.83 43 31.92 43c.81 0 4.9-.09 5.94-1.77a1.61 1.61 0 0 0 .08-1.55l-2.14-5.87c4.07-.84 6.9-4.5 6.9-9.21a9.32 9.32 0 0 0-.55-3.14A9 9 0 0 0 44 16zm-8 24.27a9.28 9.28 0 0 1-4.11.73 10.23 10.23 0 0 1-2-.11 45.87 45.87 0 0 1-1.79-6.25 21.15 21.15 0 0 1 5.64-.64zm5-20.81A9 9 0 0 0 34 16a1 1 0 0 0 0 2 6.86 6.86 0 0 1 6.12 3.73l.09.22a7.75 7.75 0 0 1 .49 2.65c0 4.19-2.62 7.23-6.42 7.39H34c-1.88 0-5.24.13-7.21 1a3.91 3.91 0 0 1-1.89-.61 8.52 8.52 0 0 0 3.8-7.08 1.81 1.81 0 0 1 1.8-1.8 1 1 0 0 0 0-2 3.8 3.8 0 0 0-3.8 3.8 6.62 6.62 0 0 1-3.94 6 7.45 7.45 0 0 1-7.87-1.07 6.51 6.51 0 0 1-2.29-4.93 1 1 0 0 0-2 0 8.52 8.52 0 0 0 1.76 5.14 9.83 9.83 0 0 1-1.81.16c-4.66 0-8.45-3-8.45-6.7a5.54 5.54 0 0 1 .77-2.77.83.83 0 0 0 .07-.13 9 9 0 0 1 7.61-3.8 1 1 0 0 0 0-2 11.21 11.21 0 0 0-8.31 3.46A5.75 5.75 0 0 1 2 17a6 6 0 0 1 3.55-5.48 1 1 0 0 0 .57-.71A6 6 0 0 1 12 6a5.94 5.94 0 0 1 1.77.27 1 1 0 0 0 1.14-.44 6 6 0 0 1 9.22-1.16A9.44 9.44 0 0 0 20 12.5c0 .41-.78 1-2 1a1 1 0 0 0 0 2 4.63 4.63 0 0 0 3-1 4.63 4.63 0 0 0 3 1 1 1 0 0 0 0-2c-1.22 0-2-.59-2-1A7.48 7.48 0 0 1 34.61 7a9.09 9.09 0 0 0-5.56 2.22 1 1 0 0 0-.05 1.44 1 1 0 0 0 .75.34 1 1 0 0 0 .66-.25 6.82 6.82 0 0 1 6.19-1.57A7 7 0 0 1 42 16a7.08 7.08 0 0 1-.92 3.46z"
              transform="translate(0 -1)"
            />
          </svg>
        </div>

        <h3>Innovative approach</h3>
        <p>
          Efficient, innovative techniques promote core understanding and
          improve numerical skills
        </p>
      </div>
    </article>
    <article class="sub-hero-item sub-hero-item3">
      <div class="sub-hero-content">
        <div class="icon-wrapper">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="35"
            height="41"
            viewBox="0 0 34.91 41.24"
          >
            <path
              fill="#6d60b0"
              d="M37.17 43H6.62a2.19 2.19 0 0 1-2.18-2.18V3.94a2.19 2.19 0 0 1 2.18-2.18h30.55a2.19 2.19 0 0 1 2.18 2.18v36.88A2.19 2.19 0 0 1 37.17 43zM8.8 38.64H35V6.12H8.8z"
              transform="translate(-4.44 -1.76)"
            />
            <path
              fill="#6d60b0"
              d="M21.9 35.74A2.75 2.75 0 1 1 24.65 33a2.76 2.76 0 0 1-2.75 2.74zm0-4.36A1.61 1.61 0 1 0 23.5 33a1.61 1.61 0 0 0-1.6-1.62z"
              transform="translate(-4.44 -1.76)"
            />
          </svg>
        </div>

        <h3>Technology</h3>
        <p>
          Engagment: Unique Educational Set is creatively designed to give
          students real-time encouragement
        </p>
      </div>
    </article>
  </div>

  <div class="mission-btn">
    <span class="btn-wrap btn-wrap1">
      <a class="btn btn--white" routerLink="/pages/public/mission"
        ><span class="btn-text">Mission and vision</span
        ><span class="btn-arrow fa fa-long-arrow-right"></span
      ></a>
    </span>
  </div>
</section>

<section class="price-block" [ngClass]="block3Animate ? 'active' : ''">
  <div class="container">
    <article class="box-images">
      <img src="/assets/images/pages/main/box-contents.jpg" alt="ZoomyBox" class="box-image">
    </article>

    <article class="section-text">
      <h2>Starts at $19.95</h2>
      <span class="btn-wrap btn-wrap1">
        <a class="btn btn--white" routerLink="/pages/public/contacts"><span class="btn-text">Join now!</span><span class="btn-arrow fa fa-long-arrow-right"></span></a>
      </span>
    </article>
  </div>
</section>

<section class="inside-box" [ngClass]="block4Animate ? 'active' : ''">
  <div class="container">
    <article>
      <h2>Inside the Box</h2>
      <p>
        Twice a month, a beautiful ZoomyBox is delivered directly to your door.
        Let’s see what’s inside!
      </p>
      <span class="btn-wrap btn-wrap1">
        <a class="btn btn--white" (click)="toggle()"
          ><span class="btn-text">Open the Box</span
          ><span class="btn-arrow fa fa-long-arrow-right"></span
        ></a>
      </span>
      <img
        src="assets/images/global/inside-box-img.png"
        alt="ZoomyBox"
        class="arrow-img blink"
      />
    </article>
  </div>
  <div class="big-box-img">
    <img src="assets/images/global/big-box-img2.png" alt="ZoomyBox" />
  </div>
</section>

<section class="education" [ngClass]="block5Animate ? 'active' : ''">
  <article
    class="bgr-img"
    style="background-image: url(/assets/images/global/education-img.jpg)"
  ></article>
  <article class="education-content">
    <img src="/assets/images/pages/about/heart.png" alt="" class="heart-img" />
    <div>
      <h2>Why ZoomyBox is good for your child</h2>
      <p>
        By combining our innovative approach, state-of-the-art educational
        practice, and traditional workbooks, your child learns Math with comfort
        and ease.
      </p>
    </div>
    <img
      src="/assets/images/global/blue-box-img.png"
      class="blue-box"
      alt="ZoomyBox"
    />
  </article>
</section>

<section class="step-to-success" [ngClass]="block6Animate ? 'active' : ''">
  <div class="container">
    <img
      src="assets/images/global/drop-box1.png"
      class="drop-box"
      alt="ZoomyBox"
    />
    <article class="section-text">
      <h2>Steps to Success</h2>
      <p>
        ZoomyBox is designed to help your child succeed and achieve learning
        goals faster. Let’s get started!
      </p>
    </article>
    <div class="success-wrap-items">
      <div class="success-item">
        <div class="success-item-content">
          <div
            class="img-wrapper"
            style="background-image: url('/assets/images/books/book_1.jpg')"
          ></div>
          <div class="text-content">
            <div class="numb">1</div>
            <h4>
              Book 1.<br />
              Sorting and classifying.<br /> Patterns.
            </h4>
            <p>
              Sort and classify objects by attributes (color, size, shape,
              etc.). Learn patterns, develop critical thinking skills, and form
              logical connections creating patterns.
            </p>
          </div>
        </div>
      </div>
      <div class="success-item">
        <div class="success-item-content">
          <div
            class="img-wrapper"
            style="background-image: url('/assets/images/books/book_2.jpg')"
          ></div>
          <div class="text-content">
            <div class="numb">2</div>
            <h4>
              Book 2.<br />
              Numbers 1 – 10.<br />Collecting Data. Graphs.
            </h4>
            <p>
              Practice collecting data through different everyday activities and
              organizing it using graphs, tally marks, charts, pictures, or
              drawings.
            </p>
          </div>
        </div>
      </div>
      <div class="success-item">
        <div class="success-item-content">
          <div
            class="img-wrapper"
            style="background-image: url('/assets/images/books/book_3.jpg')"
          ></div>
          <div class="text-content">
            <div class="numb">3</div>
            <h4>
              Book 3.<br />
              Numbers up to 20.<br /> Place Value.
            </h4>
            <p>
              Count from 1 to 20 using traditional numbers and learn to describe
              the number using Place Value. Understanding place value is
              essential for the whole course of Math.
            </p>
          </div>
        </div>
      </div>
      <div class="success-item">
        <div class="success-item-content">
          <div
            class="img-wrapper"
            style="background-image: url('/assets/images/books/book_4.jpg')"
          ></div>
          <div class="text-content">
            <div class="numb">4</div>
            <h4>
              Book 4.<br />
              Geometry. Measurement.
            </h4>
            <p>
              Name shapes, analyze and compare 2- and 3-dimensional shapes,
              describe their parts (number of sides and vertices/“corners”),
              compose and decompose shapes.
            </p>
          </div>
        </div>
      </div>
      <div class="success-item">
        <div class="success-item-content">
          <div
            class="img-wrapper"
            style="background-image: url('/assets/images/books/book_5.jpg')"
          ></div>
          <div class="text-content">
            <div class="numb">5</div>
            <h4>
              Book 5.<br />
              Numbers up to 100.<br /> Skip Counting.
            </h4>
            <p>
              Count to 100 by ones and by tens. Count forward and backward
              beginning from a given number within the known sequence - counting
              by 2, 5, 10.
            </p>
          </div>
        </div>
      </div>
      <div class="success-item">
        <div class="success-item-content">
          <div
            class="img-wrapper"
            style="background-image: url('/assets/images/books/book_6.jpg')"
          ></div>
          <div class="text-content">
            <div class="numb">6</div>
            <h4>
              Book 6.<br />
              Addition & Subtraction.
            </h4>
            <p>
              Fluently add and subtract within 20. Solve addition and
              subtraction word problems. Decompose numbers into pairs in
              multiple ways and record each decomposition by a drawing or
              equation.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--<section class="download-app" [ngClass]="block6Animate ? 'active' : ''">
  <div class="container">
    <article class="section-text">
      <h2>Learn on the go</h2>
      <p>With ZoomyBox App, your child can study anywhere at any time.</p>
      <span class="btn-wrap btn-wrap1">
        <a class="btn btn--white" routerLink="#"><span class="btn-text">App Store</span><span class="btn-arrow fa fa-long-arrow-right"></span></a>
      </span>
      <span class="btn-wrap btn-wrap2">
        <a class="btn btn--white" routerLink="#"><span class="btn-text">Google Play</span><span class="btn-arrow fa fa-long-arrow-right"></span></a>
      </span>
    </article>

    <article class="mobile-images">
      <img src="/assets/images/pages/main/mobile-img1.png" alt="ZoomyBox" class="mobil-img1">
      <img src="/assets/images/pages/main/mobile-img2.png" alt="ZoomyBox" class="mobil-img2">
    </article>
    <div class="download-box">
      <img src="/assets/images/pages/main/small-box.png"  alt="ZoomyBox">
    </div>

  </div>
</section>-->

<section class="review-section" [ngClass]="block7Animate ? 'active' : ''">
  <div class="container">
    <img
      src="assets/images/global/drop-box.png"
      class="drop-box"
      alt="ZoomyBox"
    />

    <article class="section-text">
      <h2>Why ZoomyBox?</h2>
      <p>Why kids (and parents!) love us</p>
    </article>
    <div class="review-wrap-items">
      <div class="review-item" *ngFor="let review of mainReviews">
        <div
          class="review-item-content"
          [routerLink]="['/pages/public/reviews']"
        >
          <div
            class="img-wrapper"
            [style.background-image]="review.ImageFile"
          ></div>
          <div class="text-content">
            <h4>{{ review.Name }}</h4>
            <p>{{ review.Review | shorten : 197 : "..." }}</p>
          </div>
        </div>
      </div>
      <div *ngIf="mainReviews.length === 0">There are no reviews yet</div>
    </div>
  </div>
</section>

<section class="gift" [ngClass]="block8Animate ? 'active' : ''">
  <article class="gift-content">
    <img
      src="assets/images/global/drop-box.png"
      class="drop-box"
      alt="ZoomyBox"
    />
    <div>
      <h2>Great GIFT for an awesome KID!</h2>
      <p>
        There's always a good reason to show someone they mean a lot to you.
        Order ZoomyBox as a GIFT for your love ones.
      </p>
      <span class="btn-wrap btn-wrap1">
        <a class="btn btn--white" routerLink="/pages/public/contacts"
          ><span class="btn-text">Give a GIFT</span
          ><span class="btn-arrow fa fa-long-arrow-right"></span
        ></a>
      </span>
    </div>
  </article>
  <article
    class="bgr-img"
    style="background-image: url(/assets/images/global/gift-img.jpg)"
  ></article>
</section>

<section class="get-box" [ngClass]="block9Animate ? 'active' : ''">
  <div class="container">
    <article>
      <h2>Get your ZoomyBox</h2>
      <p>
        Innovative learning technologies, creative methods, interactive
        activities, RESULTS YOU CAN COUNT ON
      </p>

      <span class="btn-wrap btn-wrap1">
        <a class="btn btn--white" routerLink="/pages/public/contacts"
          ><span class="btn-text">Get it NOW</span
          ><span class="btn-arrow fa fa-long-arrow-right"></span
        ></a>
      </span>
      <img
        src="assets/images/global/inside-box-img-white.png"
        alt="ZoomyBox"
        class="arrow-img blink"
      />
    </article>
    <article class="big-box-img">
      <img src="assets/images/global/box_vertical_new.png" alt="ZoomyBox" />
    </article>
  </div>
</section>

<!-- <app-share></app-share> -->
